import { Bar, mixins } from 'vue-chartjs';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { ChartData } from 'chart.js';

const { reactiveProp } = mixins;

@Component({
  extends: Bar,
  mixins: [reactiveProp],
})
export default class PsBarChart extends Mixins(reactiveProp, Bar) {
  @Prop() chartData!: ChartData;
  @Prop() options!: object;

  mounted() {
    this.renderChart(this.chartData, this.options);
  }
}
